import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor() { }
  allImages = [];    
    
    getImages() {    
      if(this.allImages.length==0){
        for(let i=0; i < 23;i++){
          this.allImages.push({"id":0,"url":"assets/images/gallery/picture_"+i})
        } 
      }
        
        return this.allImages
    }    
    
    getImage(id: number) {   
      if(this.allImages.length==0){
        this.allImages=this.getImages() 
      }
       
        return this.allImages[id]    
    }    
}    


